// extracted by mini-css-extract-plugin
export default {"ChangeDateBox":"ChangeSettingsButton_ChangeDateBox__pu3FG","ChangeDateIcon":"ChangeSettingsButton_ChangeDateIcon__m6gC+"};